import React, { useState } from 'react';
import Home from '../../images/nav/home.png';
import ChargeEvents from '../../images/nav/charge_events.png';
import User from '../../images/nav/user.png';
import { Dropdown, } from 'react-bootstrap';
import './navBar.scss';
import bar from '../../images/bar.png';
import logo from '../../images/logo/logo1.png';
import userIcon from '../../images/user1.png';
import setting from '../../images/nav/settings.png';

import { Link, NavLink } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';
import { useHistory } from 'react-router-dom';

const NavBar = () => {
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);
  const exPath = document?.location?.pathname

  const history = useHistory()
  const { user, handleSignOut } = useAuth()

  return (
    <>
      <div className="navbar-area ">
        <div className="navleft">
          <button onClick={showSidebar} className="navToggle"><img src={bar} alt="" /></button>
          <Link to="/"><img src={logo} alt="" /></Link>
        </div>
        <div className="navright ">
          <Dropdown onClick={() => handleSignOut(history)} align="end" className="navUser" id="dropdown-menu-align-end">
            <span className="Uname">{user.Email || user}</span> <img src={userIcon} alt="" />
          </Dropdown>
        </div>
      </div>

      <nav className={sidebar ? 'sidebarNav active' : 'sidebarNav'}>
        <ul className='nav-menu-items' onClick={showSidebar}>
          <li className='nav-text'>
            <NavLink to="/" className={exPath === "/" || exPath === "/wallbox_single" ? "navSelected" : ""}>
              <img src={Home} alt="" />
              <span className="text">Dashboard</span>
            </NavLink>
          </li>
          <li className='nav-text'>
            <NavLink to="/chargeEvents" className={exPath === "/chargeEvents" && "navSelected"}>
              <img src={ChargeEvents} alt="" />
              <span className="text">Charge Events</span>
            </NavLink>
          </li>
          <li className='nav-text'>
            <NavLink to="/users" className={exPath === "/users" || exPath === "/user_single" || exPath === "/roles" || exPath === "/permissions" ? "navSelected" : ""}>
              <img src={User} alt="" />
              <span className="text">User</span>
            </NavLink>
          </li>
        </ul>
        <ul className="bottomList">
          <li><Link to="/"><img src={setting} alt="" /></Link></li>
        </ul>
      </nav>

    </>
  )
}

export default NavBar
